// extracted by mini-css-extract-plugin
module.exports = {"UnsubscribeForm":"UnsubscribeForm","UnsubscribeForm__formHolder":"UnsubscribeForm__formHolder"};